/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const GetStudentsCoTeachersR200ResponseInnerCoTeachersInnerEnvironmentEnum = {
    UsInSchool: 'us_in_school',
    UsNoSchool: 'us_no_school',
    OutsideUs: 'outside_us'
};
/**
 * @export
 */
export const GetStudentsCoTeachersR200ResponseInnerCoTeachersInnerRoleEnum = {
    Teacher: 'teacher',
    InstructionalCoach: 'instructional_coach',
    SpecialEducationTeacher: 'special_education_teacher',
    CurriculumCoordinator: 'curriculum_coordinator',
    DirectorOfCurriculum: 'director_of_curriculum',
    RtiCoordinator: 'rti_coordinator',
    TechCoordinator: 'tech_coordinator',
    DirectorOfTechnology: 'director_of_technology',
    AssistantPrincipal: 'assistant_principal',
    Principal: 'principal',
    AssociateSuperintendent: 'associate_superintendent',
    Superintendent: 'superintendent',
    OtherDistrictLevelAdministrator: 'other_district_level_administrator',
    Parent: 'parent',
    Student: 'student',
    Other: 'other'
};
/**
 * Check if a given object implements the GetStudentsCoTeachersR200ResponseInnerCoTeachersInner interface.
 */
export function instanceOfGetStudentsCoTeachersR200ResponseInnerCoTeachersInner(value) {
    if (!('courseMembershipIds' in value) || value['courseMembershipIds'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('emailVerified' in value) || value['emailVerified'] === undefined)
        return false;
    if (!('firstName' in value) || value['firstName'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('isIdpManaged' in value) || value['isIdpManaged'] === undefined)
        return false;
    if (!('lastName' in value) || value['lastName'] === undefined)
        return false;
    if (!('schoolId' in value) || value['schoolId'] === undefined)
        return false;
    if (!('teamMode' in value) || value['teamMode'] === undefined)
        return false;
    return true;
}
export function GetStudentsCoTeachersR200ResponseInnerCoTeachersInnerFromJSON(json) {
    return GetStudentsCoTeachersR200ResponseInnerCoTeachersInnerFromJSONTyped(json, false);
}
export function GetStudentsCoTeachersR200ResponseInnerCoTeachersInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'courseMembershipIds': json['courseMembershipIds'],
        'email': json['email'],
        'emailVerified': json['emailVerified'],
        'environment': json['environment'] == null ? undefined : json['environment'],
        'firstName': json['firstName'],
        'id': json['id'],
        'isIdpManaged': json['isIdpManaged'],
        'lastName': json['lastName'],
        'role': json['role'] == null ? undefined : json['role'],
        'schoolId': json['schoolId'],
        'teamMode': json['teamMode'],
    };
}
export function GetStudentsCoTeachersR200ResponseInnerCoTeachersInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'courseMembershipIds': value['courseMembershipIds'],
        'email': value['email'],
        'emailVerified': value['emailVerified'],
        'environment': value['environment'],
        'firstName': value['firstName'],
        'id': value['id'],
        'isIdpManaged': value['isIdpManaged'],
        'lastName': value['lastName'],
        'role': value['role'],
        'schoolId': value['schoolId'],
        'teamMode': value['teamMode'],
    };
}
